import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination, Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { deepPurple, grey } from '@mui/material/colors';
import UpdateExpiredDateModal from './UpdateExpiredDateModal';

function StickyHeadTable({ customerTasklist, fetchCustomerTasklist }) {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const [selectedCustomerRow, setSelectedCustomerRow] = useState(null);
    
    const [updateExpiredDateModalOpen, setUpdateExpiredDateModalOpen] = useState(false);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const openUpdateExpiredDateModal = (row) => {
        setSelectedCustomerRow(row);
        setUpdateExpiredDateModalOpen(true);
    };

    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
                <TableContainer sx={{ height: '100vh' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key="customerDetails" style={{ minWidth: 170 }}>{t("customer.details")}</TableCell>
                                <TableCell key="taskDetails" style={{ minWidth: 170 }}>{t("customer.taskPlan")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {customerTasklist.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        <TableCell key='customerDetails' style={{fontSize: "12px"}}>
                                            {t("customer.code")} : {row.customerNumberCode} <br/>
                                            {row.loginUserName} ( {row.clientName} ) <br/>
                                            {t("customer.actualWalletBalance")} : {row.actualWalletBalance ?? '0'} <br/>
                                            {t("customer.walletBalance")} : {row.walletBalance ?? '0'}
                                        </TableCell>
                                        <TableCell key='taskDetails' style={{fontSize: "12px"}}>
                                            {t("customer.completed")}: {row.allTimeLastTaskNumber ?? '0'}  <br/>
                                            {t("customer.currentTask")}: {row.currentTaskNumber ?? '0'}  <br/>
                                            {t("customer.currentTaskProfit")}: $ {row.currentPendingTaskProfit ?? '0'} <br/>
                                            { row.expiredDate && 
                                                <>
                                                    {t("customer.expiredDate")}: {' '}{row.expiredDate.split('T')[0]}
                                                    {' '}
                                                    <Button
                                                        style={{fontSize: "12px", padding: 'unset', minWidth: 'unset' }}
                                                        onClick={() => openUpdateExpiredDateModal(row)}
                                                    >
                                                        {t("customer.update")}
                                                    </Button>
                                                </>
                                            }<br/>
                                            <span style={{ fontWeight: 'bolder', color: row.statusID === 1 ? 'orange' : row.statusID === 2 ? 'green' : row.statusID === 3 ? 'orange' : row.statusID === 4 ? 'red' : '' }}>
                                                {
                                                    row.statusID === 1 ? t("customerTasklist.pending") 
                                                    : row.statusID === 2 ? t("customerTasklist.completed") 
                                                    : row.statusID === 3 ? t("customerTasklist.ready") 
                                                    : row.statusID === 4 ? t("customerTasklist.cancelled") 
                                                    : ''
                                                }
                                            </span>
                                            
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={customerTasklist.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>

            {selectedCustomerRow && (
                <UpdateExpiredDateModal
                    updateExpiredDateModalOpen={updateExpiredDateModalOpen}
                    setUpdateExpiredDateModalOpen={setUpdateExpiredDateModalOpen}
                    row={selectedCustomerRow}
                    fetchPresetTasklist={fetchCustomerTasklist}
                />
            )}
                
            {/* {selectedCustomerRow && (
                <UpdateAmbassadorLevelModal
                    updateAmbassadorLevelModalOpen={updateAmbassadorLevelModalOpen}
                    setUpdateAmbassadorLevelModalOpen={setUpdateAmbassadorLevelModalOpen}
                    ambassadorLevelRow={selectedCustomerRow}
                    fetchAmbassadorLevels={fetchAmbassadorLevel}
                />
            )} */}
        </>
    );
}

export default StickyHeadTable;